/**
 *
 * 方案汇报 - 路径漫游配置 1.0
 *
 * 功能点:自定义漫游:开始,暂停,继续,停止.
 * 场景:方案汇报
 *
 */
import Vue from "@/main";
import { selectRoamingPoint } from "../../../api/api";
let roamLine = null;
let roamLineGL = null;
let multiplier = 1;
let paused = true;

export function handleCustomRoaming(type, id) {
  let searchData = {
    projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
    bimRoamId: id,
    sortField: "sort",
    sortOrder: "descend",
  };
  selectRoamingPoint(searchData).then(function(res) {
    if (!res.data.data || res.data.data.length == 0) return;
    let roamData = res.data.data;
    switch (type) {
      case "start":
        roamStart(roamData, id);
        break;
      case "pause":
        roamPause();
        break;
      case "continue":
        roamContinue();
        break;
      case "stop":
        roamStop();
        break;
      default:
        break;
    }
  });
}

export function init() {
  if (roamLine) {
    roamLine.stop();
  }
  if (!roamLineGL) {
    roamLineGL = new mars3d.layer.GraphicLayer(); //飞行漫游矢量图层，避免影响其它图层展示。
    Vue.$GLOBAL.map.addLayer(roamLineGL);
  }
  document.onkeydown = function(e) {
    if (e.code === "Space" || e.code === "Enter") {
      if (roamLine) {
        if (roamLine.isPause) {
          roamContinue();
        } else if (roamLine.isStart) {
          roamPause();
        } else {
        }
      }
    } else if (e.code === "ArrowUp") {
      if (roamLine && !paused && multiplier < 3) {
        multiplier += 0.1;
        roamLine.multiplier = multiplier;
      }
    } else if (e.code === "ArrowDown") {
      if (roamLine && !paused && multiplier > 1) {
        multiplier -= 0.1;
        roamLine.multiplier = multiplier;
      }
    }
  };
}

function roamStart(roamData, id) {
  let positionArr = roamData.map((item) => {
    return [item.x, item.y, item.z];
  });
  if (!positionArr || positionArr.length < 2) return;
  //漫游初始角度
  let startHeading = parseFloat(roamData[0]["heading"]);
  let startPitch = parseFloat(roamData[0]["pitch"]);

  roamLineGL.clear();
  if (roamLine) {
    roamLineGL.removeGraphic(roamLine);
    roamLine = null;
    multiplier = 1;
  }
  if (id == 361855511957573) {
    roamLine = new mars3d.graphic.FixedRoute({
      name: "方案汇报-空中漫游",
      speed: 200,
      multiplier: multiplier, //1,
      positions: positionArr,
      camera: {
        type: "gs",
        radius: 375,
        pitch: -48,
        heading: 15,
        // pitch: startPitch,
      },
      hasCache: true, //是否记录缓存
      clockLoop: false, //是否循环播放
    });
  } else {
    roamLine = new mars3d.graphic.FixedRoute({
      name: "方案汇报-空中漫游",
      speed: 200,
      multiplier: multiplier, //1,
      positions: positionArr,
      camera: {
        type: "gs",
        radius: 1000,
        pitch: -40,
        heading: 70,
        // pitch: startPitch,
      },
      hasCache: true, //是否记录缓存
      clockLoop: false, //是否循环播放
    });
  }

  roamLineGL.addGraphic(roamLine);
  roamLine.start();
  paused = false;
}

function roamPause() {
  if (roamLine && roamLine.isStart) {
    roamLine.pause();
    paused = true;
  }
}

function roamContinue() {
  if (roamLine) {
    roamLine.proceed();
    paused = false;
  }
}

function roamStop() {
  if (roamLine) {
    roamLine.stop();
    paused = false;
  }
}

export function destroy() {
  if (roamLineGL) {
    roamLineGL.clear();
    this.$GLOBAL.map.removeLayer(roamLineGL, true);
    roamLineGL = null;
  }
  if (roamLine) {
    roamLine.stop();
    roamLine = null;
  }
}
